export default {
      id: "oc-navbar-project-usage",
      viewBox: "0 0 1024 1024",
      url: __webpack_public_path__ + "sprite.svg#oc-navbar-project",
      toString: function () {
        return this.url;
      }
    }